import { Box, styled } from "@mui/material";

interface StyledArrowIconWrapperProps {
  disabled?: boolean;
}

export const StyledArrowIconWrapper = styled(Box)<StyledArrowIconWrapperProps>`
  display: flex;

  ${({ theme: { wsc }, disabled }) => `
    color: ${wsc.palette.neutral[100]};
    opacity: ${disabled ? "0.5" : "1"};
    cursor: ${disabled ? "default" : "pointer"};
  `}
`;

export const StyledArrowIconsWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  cursor: default;
`;
